import React from 'react';
import { observer } from 'mobx-react-lite';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Collapse } from 'antd';
import { Notification } from 'element-react';
import cs from './index.module.scss';
import { useStore } from '@/models';
import PullDownIcon from '@/components/icons/PullDownIcon';

import useDocumentWidth from '@/hooks/useDocumentWidth';

import logo from '@/assets/img/footer/logo.svg';

import { useSettingList, usePartnerList } from '@/hooks/footer';
import { openMediaUrl } from '@/utils/telegram';

const { Panel } = Collapse;
interface Props {
  padding?: string | number;
}
const MbFooter: React.FC<Props> = ({ padding }) => {
  const { t } = useTranslation();
  const { account } = useStore();
  const { lang } = account;
  const { push } = useHistory();
  const docWidth = useDocumentWidth();
  const iconRate = (docWidth ?? 0) > 1060 ? 1.5 : 1;
  const settingList = useSettingList();
  const communityList = usePartnerList();
  const onClearStorage = (e: React.MouseEvent) => {
    e.stopPropagation();
    localStorage.clear();
    Notification.success({
      message: t('footer.clearCacheOK'),
      offset: 60,
      duration: 2000,
    });
    const timer = setTimeout(() => {
      clearTimeout(timer);
      window.location.reload();
    }, 300);
  };

  return (
    <div className={cs.container} style={{ paddingBottom: padding }}>
      <div className={cs.mobileContent}>
        <Collapse
          accordion
          ghost
          bordered={false}
          expandIconPosition="end"
        // expandIcon={panelProps => {
        //   const { isActive } = panelProps;
        //   return <PullDownIcon alt="" className={cx(isActive ? cs.rotate : '')} />;
        // }}
        >
          {settingList?.map(({ title, children }, index) => {
            return (
              <Panel className={cs.mobilePannel} header={title} key={index}>
                <div className={cs.mobilePanelCnt}>
                  {children?.map(({ title: subTitle, url }, i) => {
                    return (
                      <a href={url} target="_blank" rel="noopener noreferrer" key={i}>
                        {subTitle}
                      </a>
                    );
                  })}
                </div>
              </Panel>
            );
          })}
        </Collapse>

        <section className={cx(cs.xtMobileDesc)}>
          {/* <img src={logo} className={cs.logo} /> */}
          <div>{t('footer.joinLvbitCommunity')}</div>
          <div className={cs.community}>
            {communityList?.map(({ mediaType, Logo }, index) => (
              <a
                key={index}
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  openMediaUrl(mediaType || '', lang);
                }}
              >
                <Logo />
              </a>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default observer(MbFooter);
